import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Alert, Button, Col, FormControl, FormGroup, Label, Row} from 'react-bootstrap';
import Modal from '../modal-shim';
import Gallery from './Gallery';
import map from 'lodash/map';
import size from 'lodash/size';
import 'font-awesome/css/font-awesome.min.css';
import {apiRoot} from '../Api';
import {addNotification} from '../notifications';
import ModalContainer from '../containers/ModalContainer';
import FeedbackForExtraPopsContainer from '../containers/FeedbackForExtraPopsContainer';
import classNames from 'classnames';
import {isMac} from '../isMac';
import ReactTooltip from 'react-tooltip';
import Mousetrap from 'mousetrap';

const sortOptions = {
    'fileName.asc': 'name: a-z',
    'fileName.desc': 'name: z-a',
    'uploadTime.asc': 'created time: earliest first',
    'uploadTime.desc': 'created time: latest first',
    'fileSize.asc': 'size: smallest first',
    'fileSize.desc': 'size: largest first'
};

const sortOptionsControls = map(sortOptions, (label, value) => <option key={value} value={value}>{label}</option>);

export default class MyImages extends Component {
    static propTypes = {
        usageLimit: PropTypes.number,
        currentUsage: PropTypes.number,
        sortBy: PropTypes.string,
        searchInputValue: PropTypes.string,
        onSearchInputValueChange: PropTypes.func,
        onSearchTermChange: PropTypes.func,
        onSortByChange: PropTypes.func,
        images: PropTypes.array,
        lastVisitedId: PropTypes.number,
        onOpenUpload: PropTypes.func,
        selectedImages: PropTypes.array,
        onToggleSelectImage: PropTypes.func,
        onResetSelection: PropTypes.func,
        hasOpenModal: PropTypes.func,
    };

    componentDidMount() {
        Mousetrap.bind('mod+o', (e) => {
            e.preventDefault();
            this.props.onOpenUpload();
        });
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['mod+o']);
    }

    handleKey = () => {
        addNotification({message: 'You can also drag and drop images into this page', level: 'info', position: 'bl'});
    };

    handleSearchTermChanged = (e) => {
        this.props.onSearchInputValueChange(e.target.value);
    };

    render() {
        const {
            images, lastVisitedId, onOpenUpload, usageLimit, currentUsage, searchInputValue, sortBy, onSortByChange,
            selectedImages, onToggleSelectImage, onResetSelection, hasOpenModal, onSearchTermChange
        } = this.props;
        const usagePct = usageLimit < 0 ? 0 : Math.round(currentUsage / usageLimit * 100);
        const usageTitle = usageLimit < 0 ? 'You have unlimited number of pops allocated' : `${currentUsage} out of ${usageLimit} allocated pops have been used`;
        const usageStyle = usagePct < 70 ? 'success' : (usagePct < 90 ? 'warning' : 'danger');
        const limitExceeded = usageLimit >= 0 && currentUsage >= usageLimit;
        const promptForExtraPops = limitExceeded && usageLimit <= 100;
        return (
            <div style={{height: '100%'}}>
                <Row style={{margin: 10}}>
                    <Col md={8}>
                        <FormGroup className={'search has-feedback has-clear'}>
                            <FormControl
                                type="text" placeholder="Search"
                                onChange={this.handleSearchTermChanged}
                                value={searchInputValue}/>
                            <i className={classNames('form-control-clear fa fa-times form-control-feedback search-clear', {hidden: !searchInputValue})} onClick={() => onSearchTermChange('')}/>
                        </FormGroup>
                    </Col>
                    <div className="pull-right">
                        <Button
                            onClick={onOpenUpload}
                            onMouseDown={this.handleKey}
                            title={limitExceeded ? 'Upload' : ''}
                            bsStyle="success"
                            style={{width: 110}}
                            disabled={limitExceeded}
                            data-tip data-for="uploadTooltip"
                        >
                            <i className="fa fa-upload"/>{' Upload'}
                            {!limitExceeded &&
                            <ReactTooltip id="uploadTooltip" place="bottom" delayShow={400} className="dark-tool-tip" type="dark">
                                <div>{'Upload'}</div>
                                <kbd>{isMac ? 'cmd-o' : 'ctrl-o'}</kbd>
                            </ReactTooltip>
                            }
                        </Button>
                    </div>
                </Row>
                <Row style={{margin: 10}}>
                    <Col md={1}>
                        <h4><Label>{`${size(images)} images`}</Label></h4>
                    </Col>
                    <Col md={1}>
                        <h4><Label bsStyle={usageStyle} title={usageTitle}>{`usage ${usagePct}%`}</Label></h4>
                    </Col>
                    <div className="pull-right">
                        <span>{'Sort by '}</span>
                        <FormControl
                            componentClass="select"
                            style={{width: 200, display: 'inline-block'}}
                            onChange={e => onSortByChange(e.target.value)}
                            value={sortBy}
                            title={sortOptions[sortBy]}
                        >
                            {sortOptionsControls}
                        </FormControl>
                    </div>
                </Row>
                {promptForExtraPops &&
                <Row>
                    <Col md={10}>
                        <ModalContainer hidden={promptForExtraPops} name="promptForExtraPops">{(isOpen, openModal, closeModal) => (
                            /* todo: remove the extra <div> after react 16 */
                            <div>
                                <Alert bsStyle="danger">
                                    <p>{`We see you have run through your allocation of ${usageLimit} free image pops`}</p>
                                    <a onClick={openModal}>{`Would you like to try another ${usageLimit} pops for FREE?`}</a>
                                </Alert>
                                <Modal show={isOpen} onHide={closeModal} bsSize="large">
                                    <Modal.Header closeButton/>
                                    <Modal.Body>
                                        <FeedbackForExtraPopsContainer onSuccess={closeModal} limit={usageLimit}/>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        )}</ModalContainer>
                    </Col>
                </Row>
                }
                <Row style={{height: '100%', margin: 10}}>
                    <Col md={12} style={{height: '100%'}}>
                        <Gallery
                            images={images}
                            srcPrefix={apiRoot}
                            lastVisitedId={lastVisitedId}
                            selectedImages={selectedImages}
                            onToggleSelectImage={onToggleSelectImage}
                            onResetSelection={onResetSelection}
                            hasOpenModal={hasOpenModal}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/MyImages.js